export function buildVisitEventProperties({ location, visit }: { location: string | null; visit: any }) {
  if (!visit?.PatientId) {
    return
  }

  return {
    FromDateTime: visit.FromDateTime,
    IsPatientAvailable: visit.IsPatientAvailable,
    IsNewForPatient: visit.IsNewForPatient,
    Location: location,
    Method: visit.Method,
    PatientId: visit.PatientId,
    ServiceTypeName: visit.ServiceTypeName,
    Status: visit.Status,
    ToDateTime: visit.ToDateTime,
    VisitId: visit.VisitId,
    VisitTypeName: visit.VisitTypeName,
  }
}
